import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
import Text from '../text';
const StyledPressable = styled.Pressable`
  padding: 0 16px;
`;
const Types = ['filled', 'initial', 'selected'];
const color = {
  filled: {
    text: Colors.gray500,
    headerLeft: Colors.advanceBlue400
  },
  initial: {
    text: Colors.gray300,
    headerLeft: Colors.advanceBlue400
  },
  selected: {
    text: Colors.gray500,
    headerLeft: Colors.advanceBlue500
  }
};
export default function RectangleBtn(props) {
  const type = Types.includes(props.type) ? props.type : RectangleBtn.defaultProps.type;
  return /*#__PURE__*/React.createElement(StyledPressable, {
    style: [styles.button, type === 'selected' ? styles.selected : styles.default, props.disabled && styles.disabled],
    onPress: props.onPress,
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "bold",
    color: color[type].headerLeft
  }, props.headerLeft), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: color[type].text
  }, props.children));
}
RectangleBtn.propTypes = {
  type: PropTypes.string,
  onPress: PropTypes.func,
  children: PropTypes.string,
  headerLeft: PropTypes.string,
  disabled: PropTypes.bool
};
RectangleBtn.defaultProps = {
  type: 'filled',
  onPress: () => {},
  children: '',
  headerLeft: '',
  disabled: false
};
const styles = {
  button: {
    borderRadius: 4,
    overflow: 'hidden',
    borderWidth: 2,
    height: 48,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  default: {
    backgroundColor: Colors.lightGray200,
    borderColor: Colors.lightGray200,
    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.025), 0px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  selected: {
    backgroundColor: Colors.white,
    borderColor: Colors.mint400
  },
  disabled: {
    opacity: 0.4
  }
};
//# sourceMappingURL=rectangle.js.map